module.exports = __webpack_public_path__ + "static/sketch-pads@2x-f1001b14e3e6ee20688531b35fa581f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/sketch-pads@2x.png
// module id = 2699
// module chunks = 157636680307020